/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournaments_Lib_Participant_Status_RequestedInputs */



/**
* | output |
* | --- |
* | "Requested" |
*
* @param {Tournaments_Lib_Participant_Status_RequestedInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const tournaments_lib_participant_status_requested = /** @type {((inputs?: Tournaments_Lib_Participant_Status_RequestedInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournaments_Lib_Participant_Status_RequestedInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Angefragt")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Demandé")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("已申请")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("已申請")
	if (locale === "ko") return /** @type {LocalizedString} */ ("요청됨")
	return /** @type {LocalizedString} */ ("Requested")
});